import React, { useEffect, useState } from 'react'
import { StoreProvider } from "easy-peasy";
import Routes from "./routes/";
import storeStateManager from "./store/index";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-pivottable/pivottable.css';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import colors from 'theme/colors';

// 📂 Importar o provider de popup
import { PopupProvider } from './contexts/PopupContext';
// 🎨 Importar o provider do Maker
import { MakerProvider } from './contexts/MakerContext';
// 🍞 Toast de evento
import EventToast from './components/EventToast';
// 🔑 Token manager para limpeza de sessão
import tokenManager from './utils/tokenManager';
// 🔐 Login agora vive no myplat-sso-web-vite
import { redirectToSsoLogin } from './utils/sso';


const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary,
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif', 
  },
});

/** Tempo (ms) antes do redirecionamento para o login após aviso de token inválido */
const REDIRECT_DELAY_MS = 4000;

const App = () => {
  const [invalidTokenToast, setInvalidTokenToast] = useState({ show: false, message: '' });

  useEffect(() => {
    /**
     * Escuta o evento disparado pelo interceptor do Axios quando o campo
     * `application` do JWT não corresponde a "myplatMaker".
     * Exibe uma mensagem de aviso e redireciona para o login após um delay.
     */
    const handleInvalidApplication = (event) => {
      const { application } = event.detail || {};

      setInvalidTokenToast({
        show: true,
        message:
          `Sessão inválida para esta aplicação (token de "${application || 'desconhecido'}"). ` +
          `Você será redirecionado para o login em instantes.`,
      });

      // Remove o token inválido e redireciona após o delay
      setTimeout(() => {
        tokenManager.removeToken();
        redirectToSsoLogin();
      }, REDIRECT_DELAY_MS);
    };

    window.addEventListener('invalid-application-token', handleInvalidApplication);
    return () => {
      window.removeEventListener('invalid-application-token', handleInvalidApplication);
    };
  }, []);

	return (
		<ThemeProvider theme={theme}>
		  <CssBaseline />
				<StoreProvider store={storeStateManager}>
					<MakerProvider>
						<PopupProvider>
							{/* ⚠️ Toast de token inválido (application != myplatMaker) */}
							<EventToast
								type="warning"
								show={invalidTokenToast.show}
								setShow={(show) => setInvalidTokenToast((prev) => ({ ...prev, show }))}
								message={invalidTokenToast.message}
							/>
							
							<Routes />
						</PopupProvider>
					</MakerProvider>
				</StoreProvider>			
		</ThemeProvider>
  );
}

export default App
